/* ==========================================================================
   PanelRoom > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'PANEL_ROOM::DESTROY';

const PEOPLE_ENABLE_INCREMENT = 'PANEL_ROOM::PEOPLE_ENABLE_INCREMENT';
const PEOPLE_DISABLE_INCREMENT = 'PANEL_ROOM::PEOPLE_DISABLE_INCREMENT';
const DISABLE_INCREMENT = 'PANEL_ROOM::DISABLE_INCREMENT';
const ENABLE_INCREMENT = 'PANEL_ROOM::ENABLE_INCREMENT';
const SET_ROOM = 'PANEL_ROOM::SET_ROOM';
const ADD_PEOPLE = 'PANEL_ROOM::ADD_PEOPLE';
const REMOVE_PEOPLE = 'PANEL_ROOM::REMOVE_PEOPLE';

const SET_AGE = 'PANEL_ROOM::SET_AGE';
const CHANGE = 'PANEL_ROOM::CHANGE';

/* Actions */
const destroy = () => ({ type: DESTROY });

const setRoom = payload => ({ type: SET_ROOM, payload });
const addPeople = payload => ({ type: ADD_PEOPLE, payload });
const removePeople = payload => ({ type: REMOVE_PEOPLE, payload });
const setAge = payload => ({ type: SET_AGE, payload });
const change = () => ({ type: CHANGE });
const peopleEnableIncrement = payload => ({ type: PEOPLE_ENABLE_INCREMENT, payload });
const peopleDisableIncrement = payload => ({ type: PEOPLE_DISABLE_INCREMENT, payload });
const enableIncrement = () => ({ type: ENABLE_INCREMENT });
const disableIncrement = () => ({ type: DISABLE_INCREMENT });

/* Exports */
module.exports = {
    types: {
        DESTROY,
        SET_ROOM,
        ADD_PEOPLE,
        REMOVE_PEOPLE,
        SET_AGE,
        CHANGE,
        PEOPLE_DISABLE_INCREMENT,
        PEOPLE_ENABLE_INCREMENT,
        ENABLE_INCREMENT,
        DISABLE_INCREMENT
    },
    actions: {
        destroy,
        setRoom,
        addPeople,
        removePeople,
        setAge,
        change,
        peopleDisableIncrement,
        peopleEnableIncrement,
        enableIncrement,
        disableIncrement
    }
};
